module.exports = __webpack_public_path__ + "media/images/ig-icon-97e54ad0.png";